import { render } from "./flats-crm-modal.vue?vue&type=template&id=5fb3f8ea"
import script from "./flats-crm-modal.vue?vue&type=script&lang=js"
export * from "./flats-crm-modal.vue?vue&type=script&lang=js"

import "./flats-crm-modal.vue?vue&type=style&index=0&id=5fb3f8ea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__